import { ClubPage } from "components/ClubPage"
import { Pagination } from "components/Pagination"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { Wrapper } from "components/Wrapper"
import { TestimonyCard } from "domains/testimony/TestimonyCard"
import * as TestimonyFilterType from "enums/TestimonyFilterType"
import { Tab, TabList, Tabs } from "components/Tab"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { useRouter } from "components/Router"

export function ClubTestimonyIndexPage({ testimonies, pagination, type }) {
  const translator = useTranslator()
  const router = useRouter()

  const tabs = [
    {
      label: translator.trans(
        "club.testimony.index.allTabTitle",
        null,
        "pages",
      ),
      id: "all",
      href: router.generate("app_club_testimony_index", {
        type: TestimonyFilterType.ALL,
      }),
      isCurrent: type === TestimonyFilterType.ALL,
    },
    {
      label: translator.trans(
        "club.testimony.index.ownerTabTitle",
        null,
        "pages",
      ),
      id: "owner",
      href: router.generate("app_club_testimony_index", {
        type: TestimonyFilterType.OWNER,
      }),
      isCurrent: type == TestimonyFilterType.OWNER,
    },
    {
      label: translator.trans(
        "club.testimony.index.crewTabTitle",
        null,
        "pages",
      ),
      id: "crew",
      href: router.generate("app_club_testimony_index", {
        type: TestimonyFilterType.CREW,
      }),
      isCurrent: type == TestimonyFilterType.CREW,
    },
  ]

  return (
    <ClubPage
      title={translator.trans("club.testimony.index.title", null, "pages")}
      googleReviewsWidget={true}
    >
      <Wrapper>
        <div className="space-y-6">
          <Tabs
            currentPanel={tabs.find((tab) => tab.isCurrent).id}
            onChange={() => null}
          >
            <TabList>
              {tabs.map((tab) => {
                return (
                  <Tab
                    key={tab.label}
                    label={tab.label}
                    id={tab.id}
                    href={tab.href}
                  />
                )
              })}
            </TabList>
          </Tabs>
          {testimonies.length > 0 ? (
            <div className="space-y-10">
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 0: 1, 640: 2, 768: 3, 1024: 4 }}
              >
                <Masonry gutter={16}>
                  {testimonies.map((testimony) => {
                    return (
                      <div key={testimony.id}>
                        <TestimonyCard testimony={testimony} />
                      </div>
                    )
                  })}
                </Masonry>
              </ResponsiveMasonry>
              <Pagination
                currentPageNumber={pagination.currentPageNumber}
                itemNumberPerPage={pagination.itemNumberPerPage}
                totalItemCount={pagination.totalItemCount}
                pageRange={2}
              />
            </div>
          ) : (
            <Text tag="p">
              {translator.trans(
                "club.testimony.index.emptyMessage",
                null,
                "pages",
              )}
            </Text>
          )}
        </div>
      </Wrapper>
    </ClubPage>
  )
}
